import React from 'react'
import { nl2br } from '../../helpers/nl2br'

const M21Colors = ({ colorName, body, samples, anchorLinkId }) => (
  <section className="my-11 sm:my-20 lg:my-24" id={anchorLinkId}>
    <div className="container">
      <div className="row-type-j">
        <div className="z-20 col-1-type-j">
          <div className="column-indent mb-11 sm:mb-0">
            <h2 className="mb-3 font-bold u-p">{colorName}</h2>
            {body && (
              <div
                className="u-p link-wrapper"
                dangerouslySetInnerHTML={{ __html: body }}
              />
            )}
          </div>
        </div>
        <div className="col-2-type-j">
          <div className="grid grid-cols-3 gap-5 pt-8 xl:grid-cols-4">
            {samples.map(sample => (
              <div
                key={sample.sampleTitle}
                className="relative w-full h-24 bg-center bg-cover group pt-[100%] rounded-full"
                style={{ backgroundImage: `url(${sample.image[0].url})` }}
              >
                <div className="opacity-0 group-hover:opacity-100 transition-all absolute bg-white bottom-full left-1/2 shadow-box rounded-[5px] px-3 py-2 text-[15px] pointer-events-none w-32 mb-2.5 -ml-16">
                  <div className="font-bold">{sample.sampleTitle}</div>
                  {sample.description && (
                    <div
                      className="link-wrapper"
                      dangerouslySetInnerHTML={{
                        __html: nl2br(sample.description),
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default M21Colors
